<template>
    <!--<pre class="vm-pre-box" :class="{pointer: !is_open && is_overflow}" @click="open" v-html="pre_text"><template v-if="!is_open && is_overflow">{{pre_text}}...<span class="purple fs14 pointer">展开</span></template><template v-if="is_open || !is_overflow">{{text}}</template></pre>-->

    <pre class="vm-pre-box" :class="{pointer: !is_open && is_overflow}" @click="open" v-html="html"></pre>
</template>

<script>

export default {
    name: 'pre-box',
    props: {
        text: {
            type: String,
            default: ''
        },
        n:{
            type: Number,
            default: 300
        },
        is_sign:{
            default: true
        },
    },
    data() {
        // <!-- v-no-copy="{can_copy:can_copy}" -->
        let pre_text = ''
        let is_overflow = this.text.length > this.n

        if(is_overflow){
            pre_text = this.text.substring(0, this.n)
        }
        return {
            pre_text: pre_text,
            is_overflow: is_overflow,
            is_open:false,
            is_test:true,
        };
    },
    computed:{
      html(){
          if(!this.is_open && this.is_overflow){
              let text = this.$escapeHTML(this.pre_text)
              return `${text}...<span class="purple fs14 pointer">展开</span>`
          }
          if(this.is_open || !this.is_overflow){
              return this.is_sign ? this.$sign_url(this.$escapeHTML(this.text), true) : this.$escapeHTML(this.text)
          }
      }
    },
    mounted() {
    },
    methods: {
        open(e){
            if(this.is_overflow){
                this.is_open = true
                this.pre_text = this.text
            }
            if(this.GL.ENV.is_afd_client && e.target.nodeName == 'A'){
                let url = e.target.getAttribute('href')
                this.$bridge.call("jumpToWebview", { url: url }, () => {
                    // console.log("jumpToWebview success");
                });
            }
            this.$bus.$emit('FOOTER_LOCATION')
        }
    }
};
</script>

<style lang="stylus" scoped>
.vm-pre-box {
    font-size: 16px;
    color: $black-8;
    line-height: 1.7;
    word-break: break-word;
    white-space: pre-wrap;
    font-family: -apple-system, BlinkMacSystemFontm, Helvetica Neue, Arial, PingFang SC, Hiragino Sans GB, Microsoft YaHei, WenQuanYi Micro Hei, sans-serif;

    &.fs14 {
        font-size: 14px;
    }

    &.fs12 {
        font-size: 12px;
    }

    &.black-5 {
        color: $black-5;
    }
}
</style>
